import React, { Component } from 'react'
import { connect } from 'react-redux';
import Header from '../../components/Header';
import BarraLateral from '../../components/BarraLateral';

class ConfigScreen extends Component {
    state = { 
        formPWA: { 
            bgcolors: ['',''] 
        }
    }

    changeValue = (input) => {
        const { name, value, type } = input
        var { formPWA } = this.state
        switch(type){
            case 'color': 
                formPWA.bgcolors[name.replace('bgcolors','')] = value
                break;
            case 'file':
                break;
            default:
                formPWA[name] = value 
                break;
        }
        this.setState({ formPWA })
    }

    render(){
        return(
            <div className="principal">

                <Header />

                <div className="row" style={{width:'100%',marginLeft:'auto',marginRight:'auto'}}>
                    <BarraLateral />
                    <main role="main" className="col-md-10 ml-sm-auto col-lg-10 px-3" style={customStyles.main}>
                       
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mt-3 ">
                                <li className="breadcrumb-item active" aria-current="page">Configurações</li>
                            </ol>
                        </nav>
                        
                        <div className="bg-white rounded shadow-sm p-3">
                            <div>
                            <form className="form-pwa" /*onSubmit={this.cadastrar}*/>
                                    
                                    <div className="form-group">
                                        <div className="custom-file">                            
                                            <input type="file" className="form-control custom-file-input inputFile" id="customFile" accept=".png, .jpg, .jpeg" onChange={ event => this.changeValue(event.target)} />
                                            <label style={{ textAlign:"left" }} className="custom-file-label" for="customFile">Logo</label>
                                        </div>
                                    </div> 

                                    <p className="h5 mb-3 font-weight-normal">PWA - assinatura digital</p>
                                    <div className="form-group">
                                        <div className="custom-file">                            
                                            <input type="file" className="form-control custom-file-input inputFile" id="customFile2" accept=".png, .jpg, .jpeg" onChange={ event => this.changeValue(event.target)} />
                                            <label style={{ textAlign:"left" }} className="custom-file-label" for="customFile">Logo 2</label>
                                        </div>
                                    </div>                                     
                                    <div className="form-group"> 
                                        <div style={{ display:'flex'}}>
                                            <p>Cores:</p>
                                            <input value={this.state.formPWA.bgcolors[0]} onChange={ event => this.changeValue(event.target)} style={{ marginLeft: 10 }} name="bgcolors0" type="color" className="form-control" placeholder="Cores"  />
                                            <input value={this.state.formPWA.bgcolors[1]} onChange={ event => this.changeValue(event.target)} style={{ marginLeft: 10 }} name="bgcolors1" type="color" className="form-control" placeholder="Cores" />
                                        </div>
                                    </div>   

                                    <button type="submit" className="btn btn-primary">Enviar</button>                  
                                </form>
                            </div>

                        </div>
                    </main>
                </div>

                <style>
                {
                    `
                    .inputFile.custom-file-input:lang(en)~.custom-file-label::after {
                        content: "Selecionar";
                        background-color: #007bff;
                        color: white;
                    }
                    `
                }
                </style>

            </div>
        )
    }
}

const customStyles = {
    main: {
        // paddingLeft: '2%',
        // paddingRight: '2%'
    }
}

const mapStateToProps = ({ auth, documentos }) => {
    return {
        documentos, auth
    }
}

export default connect(mapStateToProps, {

})(ConfigScreen);